import type { AuditEntry } from '@domain/types/audit-log';

export interface ActivityUser {
  /** Filter key: the user's id, or their name for id-less actors (e.g. System). */
  key: string;
  name: string;
}

/**
 * Distinct users present in the reconstructed log, in first-seen order. Derived from the log itself
 * (not a live tenant list) so it lists only users who made a change and keeps disabled users with
 * their recorded name. `everyone` is added by the UI, not here.
 */
export const deriveUsers = (entries: AuditEntry[]): ActivityUser[] => {
  const seen = new Map<string, ActivityUser>();
  for (const { user } of entries) {
    if (!user) continue;
    const key = user.id || user.name;
    if (!seen.has(key)) seen.set(key, { key, name: user.name });
  }
  return [...seen.values()];
};
